import React from 'react';
import { useParams } from 'react-router-dom';
import ProductEditor from '../components/products/editor/ProductEditor';
export default function ProductEditorPage() { const { id } = useParams(); return <ProductEditor productId={id ? Number(id) : null} />; }
